/**
 *  @class
 *  @function ScrollToNext
 */
if (!customElements.get('scroll-to-next')) {
	class ScrollToNext extends HTMLElement {
		constructor() {
			super();
			this.pageHeight = window.innerHeight;
		}

		connectedCallback() {
			this.addEventListener('click', this.onClick);
			this.addEventListener('touchstart', this.onClick, {
				passive: true
			});
			window.addEventListener('scroll', this.checkVisible.bind(this));
		}

		checkVisible(event) {
			window.requestAnimationFrame(() => {
				let y = window.scrollY;
				if (y < this.pageHeight) {
					this.classList.add('scroll-to-next--active');
				} else {
					this.classList.remove('scroll-to-next--active');
				}
			});
		}

		onClick() {
			window.scrollTo({
				top: this.pageHeight,
				left: 0,
				behavior: "smooth"
			});
		}
	}
	customElements.define('scroll-to-next', ScrollToNext);
}
